import axios from "axios";
import { message } from "antd";
import qs from "qs";
import createHistory from "../createHistory";
import { t } from "i18next";

/**
 * @msg: 退出登录，给出提示
 * @param {type}
 * @return {type}
 */
export function logout(msg) {
  const history = createHistory();
  if (history?.location?.pathname?.includes("/login")) {
    // 检测当前页已经是login页面，就不再执行下面的操作了
    return;
  }
  window.localStorage.removeItem('authorization')
  window.localStorage.removeItem('useInfo')
  message.destroy(); // 全局清除消息
  if (!window.location.href.includes('/register')) {
    message.error({
      content: msg || t("LoginIsInvalid"),
      duration: 2,
      onClose: () => {
        history.push("/login");
      },
      key: "loginOut", // 通过设置key，来确保只弹窗一次
    });
  }
}

const instance = axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? "https://apidocs.unifydropshipping.com/star"
      : "/star",
  timeout: 100000,
  // withCredentials:true,
  paramsSerializer: function (params) {
    return qs.stringify(params, { arrayFormat: "comma" });
  },
});

// 存储接口数据，用于axios取消
let cancelArr = []
// 请求拦截
instance.interceptors.request.use(
  (config) => {
    const { params = {} } = config;
    config.headers["Content-Security-Policy"] = `frame-ancestors 'none'`
    console.log(config.url, '--------config.url')
    if ((config.url.includes("/oauth/auth/login") || !config.url.includes("/login")) && !params.noAuthorization) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      let authorization = sessionStorage.getItem("authorization") || localStorage.getItem("authorization") || '';
      if (authorization) {
        config.headers.Authorization = authorization
      } else {
        if (!config.url.includes("/auth/reg/email/valid") && !config.url.includes("/auth/registry") && !config.url.includes("/auth/resetPwd") && !config.url.includes("auth/reg/email/restPwdValid")) {
          logout();
        }
      }
    }

    // axios取消
    cancelArr = cancelArr.filter(item => {
      if (item.url === config.url && item.method === config.method) {
        item.fn()
        return false
      }
      return true
    })
    if (config.cancelFlag) {
      config.cancelToken = new axios.CancelToken(cancelFn => {
        cancelArr.push({
          url: config.url,
          method: config.method,
          fn: cancelFn
        })
      })
    }

    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);
instance.interceptors.response.use(
  (res) => {
    // res = { status, data = {}, statusText,config }
    const { data = {}, headers } = res;
    if (headers.Authorization || headers.authorization) {
      if (res.config.url&&res.config.url.includes('/loginByErp')) { // ERP跳转
        sessionStorage.setItem(
          "authorization",
          headers.authorization || headers.Authorization
        );
      } else {
        localStorage.setItem(
          "authorization",
          headers.authorization || headers.Authorization
        );
      }
    }
    const { code, message } = data;
    if ([-305, -502].includes(code)) {
      logout(message);
      return Promise.reject();
    }
    return data;
  },
  (error) => {
    const { data } = error?.response ?? {};
    const { code, message } = data || {};
    if (code) {
      if ([-305].includes(code)) {
        logout(message);
        return;
      }
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  }
);

export default instance;
